import { apiClient } from './client.js';

export const profileApi = {
  get: () => apiClient.get('/profile'),
  update: (payload) => apiClient.patch('/profile', payload),
  changePassword: (payload) => apiClient.post('/profile/password', payload),
};
